module.exports = __webpack_public_path__ + "static/media/digital6.37e3797f.png";